import { Box, Grid } from '@mui/material'
import { AutocompleteComponent } from 'components/Autocomplete/AutocompleteComponent'
import RegularButton from 'components/CustomButtons/Button'
import { useForm } from 'hooks/useForm'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { postNfcUnit, putNfcUnit, deleteNfcUnit } from 'redux/actions/unitsSection/unitsAction';
import { ModalV2 } from "components/Modal/ModalV2";
import { useToggle } from "hooks/useToggle";
import { PERMISSIONS } from "router/permissions";

const {
    UNIT_NFC_TAG_DELETE,
} = PERMISSIONS

export const AddNfc = (props) => {
    const {
        data,
        onClose
    } = props

    const dispatch = useDispatch()
    const { nfcTags } = useSelector(({ nfcTags }) => nfcTags)
    const { rules } = useSelector(({ login }) => login)
    const { isLoadingComp } = useSelector(({ search }) => search)
    const { inputValues, handleNewValues } = useForm({ nfc: null })
    const [nfcTagsMap, setNfcTagsMap] = useState([])
    const [openDelete, setOpenDelete] = useToggle()
    const ruleDeleteNfcUnit = rules.includes(UNIT_NFC_TAG_DELETE)

    const { nfc } = inputValues

    const handleSubmit = () => {
        const body = {
            idUnit: data?.id,
            idNfcTag: nfc?.id || null,
            uuidTag: nfc?.uuidTag,
        }
        if (data?.nfcTag?.id) dispatch(putNfcUnit(body, data?.nfcTag?.id, onClose))
        else dispatch(postNfcUnit(body, onClose));
    }

    const handleDelete = () => {
        const body = {
            idUnit: data?.id,
            idNfcTag: nfc?.id,
            uuidTag: nfc?.uuidTag,
        }
        dispatch(deleteNfcUnit(body, setOpenDelete, onClose))
    }

    useEffect(() => {
        if (data?.nfcTag) handleNewValues({ nfc: Object.values(nfcTags).find(n => n?.id === data?.nfcTag?.id) })
    }, [data?.nfcTag])

    useEffect(() => {
        setNfcTagsMap(Object(nfcTags).filter(n => n?.status === "FREE"))
    }, [nfcTags])

    return (
        <Grid item sx={12} sm={12} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <AutocompleteComponent
                name="nfc"
                size={"small"}
                value={nfc}
                search="nfc"
                options={nfcTagsMap}
                label="NFC *"
                handleValues={handleNewValues}
                fullWidth
            />
            <Box style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: 32
            }}>
                <RegularButton color="transparent" onClick={onClose}>
                    Cancelar
                </RegularButton>
                {data?.nfcTag?.id && ruleDeleteNfcUnit ?
                    <RegularButton color="danger" onClick={setOpenDelete}>
                        Eliminar
                    </RegularButton> : null
                }
                <RegularButton color="info" onClick={handleSubmit} >
                    {data?.nfcTag?.id ? "Editar" : "Guardar"}
                </RegularButton>
            </Box>
            <ModalV2
                open={openDelete}
                onClose={setOpenDelete}
                title={`¿Estas seguro de eliminar etiqueta NFC ${data?.nfcTag?.uuidTag}?`}
                justConfirm
                onSubmit={handleDelete}
                isLoading={isLoadingComp?.loadingUnitsActions}
            />
        </Grid>
    )
}